import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from '../interfaces/reducer';

const initialState: IState = {
  dataDemo: [],
  dataLibraryMedia: null,
  dataLibraryLinks: null,
  allFoldersInStore: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getDemoData.success, (state, { payload }) => {
        state.dataDemo = payload;
      })
      .addCase(actions.getListLibraryMedia.success, (state, { payload }) => {
        state.dataLibraryMedia = payload;
      })
      .addCase(actions.getLibraryLinks.success, (state, { payload }) => {
        state.dataLibraryLinks = payload;
      })
      .addCase(actions.getAllFoldersInStore.success, (state, { payload }) => {
        state.allFoldersInStore = payload;
      });
  },
});

/** TODO:
 * please replace media => your feature name
 * ex:
 *      my feature is booking 
 *  name sagas like
 *      mediaServiceReducer => bookingServiceReducers
 * 
 * // TODO:
 * Move to rootReducer (src/store/root/reducers.ts) and import your feature reducer
 */
export const mediaUIActions = Slice.actions;
const mediaServiceReducer = Slice.reducer;
export default mediaServiceReducer;
